const HeroBanner = () => {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-r from-[#FFE5D4] to-[#FFF8F0] overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#FF8C42]/20 rounded-full blur-3xl"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center mb-6">
          <a href="/" className="text-[#6B6B6B] text-sm hover:text-[#FF8C42] transition-colors cursor-pointer">
            Home
          </a>
          <i className="ri-arrow-right-s-line text-[#6B6B6B] mx-2"></i>
          <span className="text-[#FF8C42] text-sm font-semibold">Return Policy</span>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold text-[#2A2A2A] mb-6">
          Return Policy
        </h1>
        <p className="text-xl text-[#6B6B6B] max-w-3xl">
          Understanding our freight return and claims procedures
        </p>
      </div>

      <div className="absolute bottom-0 right-12">
        <div className="w-24 h-24 border-8 border-[#FF8C42] rounded-full opacity-30"></div>
      </div>
    </section>
  );
};

export default HeroBanner;